import React from 'react';

/**
 * Report then-ables that should be awaited prior to some action proceeding
 * e.g. a blur handler for a `setValue` should be waited on prior to calling `editComplete` in a property editor.
 */
export interface IAwaitableContext {
  /** A handler that needs to be `await`ed proceeding */
  addPromise: (id: string, promise: Promise<void>) => void;
  /** Remove a handler that needs to be `await`ed proceeding. */
  removePromise: (id: string) => void;

  // additional features here could be things that also need to be invoked, not just waited on,
  // and things that need to be queued into a sequence using QueueUtil
}

export const AwaitableContext = React.createContext<IAwaitableContext>({
  addPromise: () => {
    if (IS_TEST) {
      return;
    }
    console.log('AwaitableContext.addAwaitableHandler not configured');
  },
  removePromise: () => {
    if (IS_TEST) {
      return;
    }
    console.log('AwaitableContext.removeAwaitableHandler not configured');
  },
});
